var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bg-white border br-10 px-4 secondary-btn w-24 lg:text-hint text-sm",attrs:{"type":"button"},on:{"click":_vm.handleMyBlogClick}},[_vm._v("\n  My Blog\n")])}
var staticRenderFns = []

export { render, staticRenderFns }